import { Text as RNText, StyleProp, TextStyle } from "react-native";

export const Text = ({children, className = "", style, numberOfLines}: {children: React.ReactNode, className?: string, style?: StyleProp<TextStyle>, numberOfLines?: number}) => {
    return <RNText className={`text-black text-base leading-normal ${className}`} style={style} numberOfLines={numberOfLines}>{children}</RNText>
}